(function(){
  var KEY='fmrChatHidden';
  try{ if(sessionStorage.getItem(KEY)==='1'){ document.documentElement.classList.add('fmr-chat-off'); } }catch(e){}
  var css=document.createElement('style');
  css.textContent='html.fmr-chat-off shopify-chat{display:none!important}';
  document.head.appendChild(css);
  function inject(host){
    var root=host.shadowRoot; if(!root) return false;
    var nudge=root.querySelector('.activator-nudge'); if(!nudge) return false;
    if(root.querySelector('.fmr-x')) return true;
    var st=document.createElement('style');
    st.textContent='.activator-nudge{overflow:visible!important}'+
      '.fmr-x{position:absolute;top:-8px;right:-8px;z-index:2;width:24px;height:24px;border-radius:50%;border:1px solid #d0d0cc;background:#fff;color:#212326;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;box-shadow:0 1px 4px rgba(0,0,0,.18)}'+
      '.fmr-x:hover{background:#212326;color:#fff;border-color:#212326}'+
      '.fmr-x svg{width:10px;height:10px}'+
      '.activator[aria-expanded="true"]~.fmr-x{display:none}';
    root.appendChild(st);
    if(getComputedStyle(nudge).position==='static') nudge.style.position='relative';
    var b=document.createElement('button');
    b.type='button'; b.className='fmr-x'; b.setAttribute('aria-label','Close chat');
    b.innerHTML='<svg viewBox="0 0 10 10" aria-hidden="true"><path d="M1 1l8 8M9 1l-8 8" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round"/></svg>';
    b.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();
      document.documentElement.classList.add('fmr-chat-off');
      try{sessionStorage.setItem(KEY,'1')}catch(err){}
    });
    var act=nudge.querySelector('.activator');
    if(act && act.nextSibling) nudge.insertBefore(b, act.nextSibling); else nudge.appendChild(b);
    return true;
  }
  var tries=0;
  (function poll(){
    var h=document.querySelector('shopify-chat');
    if(h && inject(h)) return;
    if(++tries<60) setTimeout(poll,500);
  })();
})();
